/*
  pof-dialogs: opens pop-ups (privacy, returns, size guide, password...).

  - Any element with data-pof-open="DialogId" opens that pop-up.
  - Any link with data-pof-privacy opens the privacy pop-up (if it exists).
  - After a wrong password, the password pop-up opens again by itself.

  We use the browser's built-in <dialog> element: it handles the Escape key,
  focus and the dark background for us, so it works well with a keyboard.
*/

(function () {
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return false;
    dialog.showModal();
    return true;
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-pof-open]');
    if (opener) {
      openDialog(opener.dataset.pofOpen);
      return;
    }

    const privacyLink = event.target.closest('[data-pof-privacy]');
    if (privacyLink && openDialog('PofPrivacyDialog')) {
      event.preventDefault(); // stay on this page and show the pop-up instead
      return;
    }

    // Clicking the dark area around a pop-up closes it.
    if (event.target instanceof HTMLDialogElement) event.target.close();
  });

  // Wrong password? Re-open the pop-up so the error message is visible.
  if (document.querySelector('[data-pof-reopen]')) {
    openDialog('PofPasswordDialog');
    document.getElementById('PofPassword')?.focus();
  }
})();
